import { z } from 'zod'

import { BusinessErrorSchema } from 'shared/api/common/schemas/errors'

/**
 * Triggered when:
 * 1. the user ID is invalid
 * 2. the user has no permission to interact with the subscriber's thread
 * 3. subscriber is inactive (unsubscribed, merged)
 */
export const CurrentThreadUserErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('user_id'),
})

/**
 * Triggered when:
 * 1. the user assigns an inactive (unsubscribed, merged) subscriber
 * 2. the user has no permission to interact with the subscriber's thread
 */
export const AssignmentErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('subscriber'),
})

export const BulkActionInProgressErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('bulk_action_in_progress'),
})
